import { SpeciesEnum } from "../../../../../__generated__/globalTypes";
import { Package, PackageFeature, PackageIcon } from "./types";

export enum limitsEnum {
  Liability = 1000000000,
  LiabilityPlus = 1000000000,
}

export enum deductiblesEnum {
  Liability = 15000,
  LiabilityPlus = 0,
}

export const plansLiability = ({
  name,
  breed,
  clientBirthdate,
  liabilityBestAddOn,
  liabilityRentedAddOn,
  liabilitySosAddOn,
  birthday,
  sex,
}: {
  name: string;
  breed: string;
  clientBirthdate: string;
  liabilityBestAddOn: boolean;
  liabilitySosAddOn: boolean;
  liabilityRentedAddOn: boolean;
  birthday: string;
  sex: string;
}) => [
  {
    limit: limitsEnum.Liability,
    deductible: deductiblesEnum.Liability,
    ratingsData: {
      name,
      breed,
      birthday,
      sex,
      clientBirthdate,
      liabilityBestAddOn,
      liabilityRentedAddOn,
      liabilitySosAddOn,
    },
  },
  {
    limit: limitsEnum.LiabilityPlus,
    deductible: deductiblesEnum.LiabilityPlus,
    ratingsData: {
      name,
      breed,
      birthday,
      sex,
      clientBirthdate,
      liabilityBestAddOn,
      liabilityRentedAddOn,
      liabilitySosAddOn,
    },
  },
];

const liabilityFeatures: PackageFeature[] = [
  {
    title: "Selbstbehalt 150 €",
  },
];

const liabilityPlusFeatures: PackageFeature[] = [
  {
    title: "Selbstbehalt 0 €",
  },
];

export const sharedFeatures: PackageFeature[] = [
  {
    title: "Schutz 10 000 000 €",
  },
  {
    title: "Mietschäden an Gebäuden",
  },
  {
    title: "Mitversicherung von Welpen",
  },
  {
    title: "Deckschäden (gewollt/ ungewollt)",
  },
  {
    title:
      "Hundehalter, Familienangehörige, nicht gewerbsmäßige Dritte mitversichert",
  },
  {
    title: "Absicherung bei Führen ohne Leine",
  },
  {
    title: "Rettungskosten bis 3 000 € pro Jahr",
  },
  {
    title: "Ausgewählte Risiken bei Freizeit & Aktivitäten versichert",
  },
  {
    title: "Auslandsaufenthalt Europa: unbegrenzter Schutz",
  },
  {
    title: "Weltweiter Auslandsaufenthalt: bis 5 Jahre",
  },
];

export const getLiabilityPackages: (
  species: SpeciesEnum | null
) => Package<limitsEnum, deductiblesEnum>[] = (species) =>
  [
    {
      name: "Hundehaftpflicht",
      icon: "meatbone" as PackageIcon,
      tagline: "",
      headline: "",
      limit: limitsEnum.Liability,
      deductible: deductiblesEnum.Liability,
      species: SpeciesEnum.dog,
      features: liabilityFeatures,
    },
    {
      name: "Hundehaftpflicht Plus",
      icon: "steak" as PackageIcon,
      tagline: "",
      headline: "",
      limit: limitsEnum.LiabilityPlus,
      deductible: deductiblesEnum.LiabilityPlus,
      species: SpeciesEnum.dog,
      features: liabilityPlusFeatures,
    },
  ].filter((pack) => pack.species === species);
